import { Button, Dialog, P } from '@dnb/eufemia';
import { trash as TrashIcon } from '@dnb/eufemia/icons';
import { useState } from 'react';

import LoadingModal from '../LoadingModal';

type DeleteDialogProps = {
  onDelete: () => void;
  text: string;
  title: string;
  loading?: boolean;
  triggerVariant?: 'secondary' | 'tertiary' | 'primary' | 'signal';
};
export default function DeleteDialog({
  text,
  title,
  loading,
  onDelete,
  triggerVariant = 'secondary',
}: DeleteDialogProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {loading && <LoadingModal />}
      <Button
        icon={TrashIcon}
        iconPosition="left"
        onClick={() => setOpen(true)}
        variant={triggerVariant === 'signal' ? 'primary' : triggerVariant}
      >
        Delete
      </Button>
      {open && (
        <Dialog
          confirmText="Delete"
          confirmType="warning"
          icon={TrashIcon}
          onConfirm={onDelete}
          onDecline={() => setOpen(false)}
          open
          right="small"
          title={title}
          triggerAttributes={{
            hidden: true,
          }}
          variant="confirmation"
        >
          <P>{text}</P>
        </Dialog>
      )}
    </>
  );
}
